var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.permissions?.hasRead || _vm.$userInfo.isSystemAdministrator
    ? _c(
        "div",
        [
          _c("app-detail-header", {
            attrs: {
              "show-toggle": true,
              "show-delete": false,
              "show-save": false,
              "show-cancel": false,
              "show-print": false,
              "show-new": true,
            },
            on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
          }),
          _c("div", { staticClass: "columns is-gapless" }, [
            _c(
              "div",
              { staticClass: "column is-narrow" },
              [
                _vm.$userInfo.isSystemAdministrator &&
                !_vm.$userInfo.isSupportUser &&
                !_vm.isCompanyUser
                  ? _c("user-list-side-menu", {
                      on: { filter: _vm.filterList, reset: _vm.resetFilter },
                      model: {
                        value: _vm.filter,
                        callback: function ($$v) {
                          _vm.filter = $$v
                        },
                        expression: "filter",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c("div", { staticClass: "column" }, [
              _c(
                "div",
                { staticClass: "m-3" },
                [
                  _c(
                    "article",
                    { staticClass: "box detail-page-tile" },
                    [
                      _c(
                        "bulma-table",
                        {
                          staticClass:
                            "table is-bordered is-striped is-narrow is-fullwidth",
                          attrs: {
                            columns: _vm.columns,
                            "is-loading": _vm.isTableLoading,
                            "page-index": _vm.filter.pageIndex,
                            "page-size": _vm.filter.pageSize,
                            "sort-column": _vm.filter.sortColumn,
                            "sort-order": _vm.filter.sortOrder,
                            "total-rows": _vm.totalRows,
                          },
                          on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                        },
                        [
                          _vm._l(_vm.users, function (user, index) {
                            return _c("tr", { key: index }, [
                              _c("td", [
                                _vm._v(" " + _vm._s(user.username) + " "),
                              ]),
                              _c("td", [_vm._v(_vm._s(user.fullName))]),
                              _c("td", { staticClass: "has-text-centered" }, [
                                _vm._v(_vm._s(user.active ? "Yes" : "No")),
                              ]),
                              _c(
                                "td",
                                {
                                  staticClass: "action-column",
                                  class: {
                                    "has-text-centered": !_vm.isCompanyUser,
                                  },
                                },
                                [
                                  !_vm.isCompanyUser
                                    ? _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: { path: `${user.userId}` },
                                            append: "",
                                          },
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "button is-primary is-small is-inverted tooltip",
                                              attrs: {
                                                "data-tooltip": "Click to edit",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "icon is-medium",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "mso mso-24px",
                                                    },
                                                    [_vm._v(" edit ")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _c("div", [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "is-primary is-small is-inverted tooltip",
                                            attrs: {
                                              "data-tooltip": "Reset Password",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.toggleResetPasswordModal(
                                                  user
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(" Reset Password ")]
                                        ),
                                      ]),
                                ],
                                1
                              ),
                            ])
                          }),
                          _c("template", { slot: "empty" }, [
                            _c("section", { staticClass: "section" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "content has-text-grey has-text-centered",
                                },
                                [
                                  _c(
                                    "span",
                                    { attrs: { icon: "icon is-large" } },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "mso mso-50px mso-fill",
                                        },
                                        [_vm._v(" sentiment_dissatisfied ")]
                                      ),
                                    ]
                                  ),
                                  _c("p", [_vm._v("Nothing")]),
                                ]
                              ),
                            ]),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm.showResetPasswordModal && _vm.isCompanyUser
                    ? _c("reset-password-modal", {
                        attrs: {
                          value: _vm.selectedUser,
                          active: _vm.showResetPasswordModal,
                        },
                        on: {
                          close: function ($event) {
                            _vm.showResetPasswordModal = false
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      )
    : _c("div", [_vm._m(0)])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "is-flex is-justify-content-center pt-5" },
      [
        _c("div", { staticClass: "notification is-danger is-flex is-size-4" }, [
          _vm._v(" You do not have permissions on this page "),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }